module.exports = __webpack_public_path__ + "media/images/boxes/phonepup-f6c51e21733645ce22500238264793c7.png";